"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SelectedContext", {
    enumerable: true,
    get: function() {
        return SelectedContext;
    }
});
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const SelectedContext = /*#__PURE__*/ _react.default.createContext({
    selected: "",
    setSelected: ()=>undefined
});

//# sourceMappingURL=SelectedContext.js.map